import { Dispatch, SetStateAction, useState } from "react";
import {
    Modal,
    Button,
    TextField,
    MenuItem,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddSubCategory({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [active, setActive] = useState(true);
    const [featured, setFeatured] = useState(false);

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* HEADER */}
                    <div className="modal_title">
                        <h2>Add Sub-Category</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* FORM */}
                    <form className="form">
                        {/* ROW 1 */}
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label htmlFor="subcategory-name">Name</label>
                                <TextField
                                    placeholder="Smartphones"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "subcategory-name" }}
                                />
                            </div>

                            <div className="control_group w_50">
                                <label htmlFor="parent-category">Parent Category</label>
                                <TextField
                                    select
                                    fullWidth
                                    hiddenLabel
                                    defaultValue="Electronics"
                                    inputProps={{ id: "parent-category" }}
                                >
                                    <MenuItem value="Electronics">Electronics</MenuItem>
                                    <MenuItem value="Clothing">Clothing</MenuItem>
                                    <MenuItem value="Home">Home &amp; Kitchen</MenuItem>
                                </TextField>
                            </div>


                            {/* DESCRIPTION */}
                            <div className="control_group w_100 ai_rec_btn">
                                <label htmlFor="subcategory-description">Description</label>
                                <TextField
                                    placeholder="Mobile phones and accessories"
                                    multiline
                                    rows={3}
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "subcategory-description" }}
                                />
                                <Button className="btn btn_primary sm">Enhance with AI</Button>
                            </div>
                          

                            {/* FOOTER */}
                            <div className="footer_btn_flex">
                                <Button
                                    className="btn btn_grey"
                                    onClick={() => setOpen(false)}
                                >
                                    Generate With AI
                                </Button>
                                <Button
                                    className="btn btn_primary"
                                    onClick={() => setOpen(false)}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
